import React from "react";
import { Link } from "react-router-dom";
import { FiXCircle } from "react-icons/fi";

const OrderCancel = () => {
  return (
    <div
      className="container text-center py-5"
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <FiXCircle size={80} className="mb-4 text-danger" />
      <h2 className="mb-3">Payment Cancelled</h2>
      <p className="text-muted mb-4">
        Your payment was not completed. Your cart has been saved.
      </p>
      <Link to="/cart" className="btn btn-warning me-2">
        Back to Cart
      </Link>
      <Link to="/shop" className="btn btn-outline-secondary">
        Continue Shopping
      </Link>
    </div>
  );
};

export default OrderCancel;
